import { NgModule } from '@angular/core';  // Adjust path to the pipe
import { RevealToggleDirective } from './directives/reveal-toggle.directive';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { AutoTabDirective } from './directives/auto-tab.directive';
import { CheckEmptyDirective } from './directives/check-empty.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { FormatCardDirective } from './directives/format-card.directive';

@NgModule({
  declarations: [
    RevealToggleDirective,
    AutoFocusDirective,
    AutoTabDirective,
    CheckEmptyDirective,
    ClickOutsideDirective,
    FormatCardDirective
  ],
  exports: [
    RevealToggleDirective,
    AutoFocusDirective,
    AutoTabDirective,
    CheckEmptyDirective,
    ClickOutsideDirective,
    FormatCardDirective

  ]  // Export the directive for global use
})
export class SharedDirectiveModule { }
